<template>
	<div>
		<div class="header">
			<h1>squarim</h1>
		</div>
		<div class="dropzone-container">
			<UploadImages
				@changed="handleImages"
				uploadMsg="Déposer les images que vous souhaitez traiter"
				clearAll="Retirer toutes les images"
				ref="dropzone"
			/>
			<div class="input-container" v-if="images.length > 0">
				<button id="rembg-btn" @click="removeBackgroundParallel">
					Lancer le traitement
				</button>
				<span>Retirer l'arrière-plan</span>
				<input type="checkbox" id="checkbox" v-model="rembg" />

				<span v-if="rembg" style="margin-right: 10px"
					>Ajouter un fond coloré</span
				>
				<ToggleButton
					v-if="rembg"
					v-model="addBgColor"
					style="margin-right: 10px"
				/>

				<Verte
					picker="square"
					v-if="addBgColor"
					v-model="bgColor"
					model="rgb"
					enableAlpha="false"
				/>
			</div>
			<div class="loader" v-if="loading">
				<AppLoader
					:message="
						serverIsReady
							? 'Traitement des images'
							: 'Lancement du serveur (cela peut prendre quelques secondes)'
					"
					style="margin-bottom: 40px; margin: auto"
				/>
			</div>
			<div v-if="transformedImages.length > 0" class="preview-container">
				<div class="preview-images-container">
					<img
						class="processed-image"
						v-for="(image, index) in transformedImages"
						:key="index"
						:src="image.image"
					/>
				</div>
				<button v-if="!loading" id="download-btn" @click="download">
					Télécharger
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import UploadImages from "vue-upload-drop-images";
import AppLoader from "./AppLoader.vue";
import { ToggleButton } from "vue-js-toggle-button";

import Verte from "verte";
import "verte/dist/verte.css";

export default {
	components: {
		UploadImages,
		AppLoader,
		Verte,
		ToggleButton,
	},
	data() {
		return {
			rembg: false,
			images: [],
			addBgColor: false,
			bgColor: "rgb(239,239,239)",
			transformedImages: [],
			loading: false,
			serverIsReady: false,
		};
	},
	methods: {
		handleImages(files) {
			this.images = [];
			this.transformedImages = [];
			for (let i = 0; i < files.length; i++) {
				let reader = new FileReader();
				reader.readAsDataURL(files[i]);
				reader.onload = () => {
					this.images.push({
						name: files[i].name,
						dataURL: reader.result,
					});
				};
			}
		},
		download() {
			for (let i = 0; i < this.transformedImages.length; i++) {
				let link = document.createElement("a");
				link.download = this.transformedImages[i].name;
				link.href = this.transformedImages[i].image;
				link.click();
			}
		},

		async removeBackground() {
			this.loading = true;
			this.transformedImages = [];
			console.time("squarim");
			const url = //"https://squarim.data.appchoose.co/autosize?";
				"https://squarim-gpu-f5ljwmnzga-uc.a.run.app/autosize?" +
				// "http://localhost:8000/autosize?" +
				new URLSearchParams({
					remove_bg: this.rembg,
					bg_color: this.bgColor,
				}).toString();

			let data;

			for (let i = 0; i < this.images.length; i++) {
				data = new FormData();
				const blob = await fetch(this.images[i].dataURL).then((r) => r.blob());
				data.append("file", blob, this.images[i].name);
				const response = await fetch(url, {
					method: "POST",
					body: data,
				});
				if (!response.ok) {
					this.transformedImages.push({
						name: this.images[i].name,
						image: URL.createObjectURL(blob),
					});
				} else {
					const blobImage = await response.blob();
					this.transformedImages.push({
						name: this.rembg
							? this.images[i].name
									.replace(".jpg", ".png")
									.replace(".jpeg", ".png")
									.replace(".webp", ".png")
							: this.images[i].name,
						image: URL.createObjectURL(blobImage),
					});
				}
			}

			this.loading = false;
			console.timeEnd("squarim");
		},

		async removeBackgroundParallel() {
			this.loading = true;
			await fetch("https://squarim-gpu-f5ljwmnzga-uc.a.run.app/").then(
				(response) => {
					if (response.status == 200) {
						this.serverIsReady = true;
					}
				}
			);
			this.transformedImages = [];
			console.time("squarim parallel");
			const url = //"https://squarim.data.appchoose.co/autosize?";
				"https://squarim-gpu-f5ljwmnzga-uc.a.run.app/autosize?" +
				// "http://localhost:8000/autosize?" +
				new URLSearchParams({
					remove_bg: this.rembg,
					bg_color: this.rembg && this.addBgColor ? this.bgColor : "",
				}).toString();

			// Create an array of promises
			const fetchPromises = this.images.map(async (image) => {
				const data = new FormData();
				const blob = await fetch(image.dataURL).then((r) => r.blob());
				data.append("file", blob, image.name);

				const response = await fetch(url, {
					method: "POST",
					body: data,
				});

				if (!response.ok) {
					this.transformedImages.push({
						name: image.name,
						image: URL.createObjectURL(blob),
					});
				} else {
					const blobImage = await response.blob();
					this.transformedImages.push({
						name: this.rembg
							? image.name
									.replace(".jpg", ".png")
									.replace(".jpeg", ".png")
									.replace(".webp", ".png")
							: image.name,
						image: URL.createObjectURL(blobImage),
					});
				}
			});

			// Wait for all promises to complete
			await Promise.all(fetchPromises);
			this.loading = false;
			console.timeEnd("squarim parallel");
		},
	},
};
</script>

<style>
.header {
	width: 100%;
	opacity: 0.9;
	padding-left: 50px;
	padding-right: 50px;
	margin-bottom: 10px;
}

.header > h1 {
	color: #1005a0;
}

.dropzone-container {
	width: 90%;
	padding-left: 50px;
	padding-right: 50px;
}

.imageHolder {
	width: unset !important;
	height: 200px;
}

.plus {
	line-height: 30px !important;
}

.delete {
	border: 1px solid red;
}

.delete:hover {
	color: red !important;
	background: white !important;
	border: 1px solid red;
}

.input-container {
	display: flex;
	align-items: center;
	justify-content: center;
}

.input-container > span {
	margin-left: 5px;
}

.input-container > input {
	text-align: right;
	margin: 8px;
}

.processed-image {
	max-width: 200px;
	object-fit: scale-down;
}

.clearButton:hover {
	color: red;
	cursor: pointer;
}

#process-btn,
#rembg-btn {
	border-radius: 25px;
	border: 1px solid #1005a0;
	padding-left: 20px;
	padding-right: 20px;
	padding-top: 10px;
	padding-bottom: 10px;
	background: #1005a0;
	color: white;
	font-weight: 600;
	font-family: Roboto;
	margin: 10px;
}

#process-btn:hover,
#rembg-btn:hover {
	background: white;
	color: #1005a0;
	font-weight: 600;
	cursor: pointer;
}

#download-btn {
	border-radius: 25px;
	border: transparent;
	padding-left: 20px;
	padding-right: 20px;
	padding-top: 10px;
	padding-bottom: 10px;
	background: #ff6c62;
	color: white;
	font-weight: 600;
	font-family: Roboto;
	margin: 10px;
}

#download-btn:hover {
	background: white;
	border: 1px solid #ff6c62;
	color: #ff6c62;
	font-weight: 600;
	cursor: pointer;
}

.preview-container {
	text-align: center;
}

.preview-images-container {
	display: flex;
	width: 100%;
	max-width: 100%;
	flex-wrap: wrap;
	position: relative;
	border-radius: 10px;
	border: 0.5px solid #a3a8b1;
	padding: 30px;
	background: #f7fafc;
}

.preview-images-container > img {
	margin: 10px;
	height: 200px;
}

.onnx-btn {
	margin: auto;
	margin-top: 20px;
	background-color: red;
	border-radius: 10px;
	color: white;
	padding: 10px;
	max-width: 100px;
	text-align: center;
}
</style>
